import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import { LegendItem } from '../../../components/Legend';
import LegendInfo from '../../../components/Legend/LegendInfo';
import { getFHAIntervals, getPercentages } from '../../../config/FHALegends';
import { FHA } from '../../../constants/mapLayerIds';
import styles from '../harvestAndPlanting/HarvestAndPlantingLegend.css';
import { FHA_EXPANDED_LEGEND_FEATURE_FLAG } from '../../../constants/featureFlags';

import {
  activeSubLayerSelector,
  currentFHAEvent,
  currentSeasonFHAEventsSelector,
} from '../../../selectors/fhaSelectors';

export class FHALegend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: true,
    };
  }

  togglePanel = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  render() {
    const { isExpanded } = this.state;
    const {
      canExpandLegend,
      intervals = [],
      isVisible,
      testId,
      layer,
    } = this.props;

    return isVisible ? (
      <div>
        <div
          className={styles.legendContainer}
          data-test-id={`${testId}-inSeason-fha`}
        >
          <LegendItem
            canExpandLegend={canExpandLegend}
            expandPanel={this.togglePanel}
            intervals={intervals}
            isExpanded={isExpanded}
            isFetching={false}
            labelHigh={getMessage(`legend.high.${layer}`)}
            labelIntervals={
              canExpandLegend &&
              `${getMessage(`legend.intervals.${layer}`)} (%)`
            }
            labelLow={getMessage(`legend.low.${layer}`)}
            onClick={this.togglePanel}
          />
        </div>
        <div className={styles.legendContainer}>
          <LegendInfo layer={layer} />
        </div>
      </div>
    ) : null;
  }
}

FHALegend.propTypes = {
  canExpandLegend: PropTypes.bool,
  intervals: PropTypes.array.isRequired,
  isVisible: PropTypes.bool.isRequired,
  layer: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
};

function mapStateToProps(state, props) {
  const { date, layer } = activeSubLayerSelector(state, props);
  const { colorScheme } = currentFHAEvent(state, props)[FHA.VEGETATION];
  const fhaExpandedLegendFeatureFlag =
    layer === 'fha.rank'
      ? state.feature.userConfigFeatures[FHA_EXPANDED_LEGEND_FEATURE_FLAG] || {}
      : false;
  const events = currentSeasonFHAEventsSelector(state, props);
  const event = events.find((e) => e.date === date);
  return {
    canExpandLegend: fhaExpandedLegendFeatureFlag.value,
    isVisible: layer !== FHA.TRUE_COLOR,
    intervals: getPercentages(
      getFHAIntervals(layer, colorScheme),
      event.percentages,
      layer
    ),
    layer,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FHALegend);
